const numbersStyle = () => ({
	header: {
		marginBottom: '8px',
		marginTop: '24px',
	},
});

export default numbersStyle;
